/** Инициали от името — първите букви на първите две думи („Мария Петрова" → „МП"). */
export const initialsOf = (label: string) =>
  label
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? "")
    .join("");
